import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { forwardRef, useContext, useEffect, useImperativeHandle, useState, } from "@wordpress/element";
import { __ } from "@wordpress/i18n";
import { ModalContext } from "../../../providers/ModalContextProvider";
import { WPQTInput } from "../../common/Input/Input";
import { WPQTTextarea } from "../../common/TextArea/TextArea";
import { WPQTModalField, WPQTModalFieldSet, WPQTModalFooter, WPQTModalTitle, } from "../WPQTModal";
const StageModalContent = forwardRef(({ editStage, addStage, stageModalSaving }, ref) => {
    const { state: { stageToEdit }, } = useContext(ModalContext);
    const [stageName, setStageName] = useState("");
    const [stageDescription, setStageDescription] = useState("");
    const editingStage = !!stageToEdit;
    useEffect(() => {
        if (stageToEdit) {
            setStageName(stageToEdit.name);
            setStageDescription(stageToEdit.description);
        }
    }, [stageToEdit]);
    const saveStage = () => {
        editingStage
            ? editStage(Object.assign(Object.assign({}, stageToEdit), { name: stageName, description: stageDescription }))
            : addStage(stageName, stageDescription);
    };
    const clearContent = () => {
        setStageName("");
        setStageDescription("");
    };
    useImperativeHandle(ref, () => ({
        clearContent,
    }));
    return (_jsxs(_Fragment, { children: [_jsx(WPQTModalTitle, { children: editingStage
                    ? __("Edit Stage", "quicktasker")
                    : __("Add Stage", "quicktasker") }), _jsxs(WPQTModalFieldSet, { children: [_jsx(WPQTModalField, { label: __("Name", "quicktasker"), children: _jsx(WPQTInput, { isAutoFocus: true, value: stageName, onChange: (newValue) => setStageName(newValue) }) }), _jsx(WPQTModalField, { label: __("Description", "quicktasker"), children: _jsx(WPQTTextarea, { rowsCount: 3, value: stageDescription, onChange: (newValue) => setStageDescription(newValue) }) })] }), _jsx(WPQTModalFooter, { onSave: saveStage, loading: stageModalSaving, saveBtnText: editingStage
                    ? __("Save", "quicktasker")
                    : __("Add stage", "quicktasker") })] }));
});
export { StageModalContent };
